module.exports = __webpack_public_path__ + "static/introInfo-f01460759860a949a66ec2c26a8cecb6.png";